var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nuttrema-medium-editor",class:[ _vm.disabled ? 'is-disabled' : '' ]},[_c('medium-editor',{attrs:{"custom-tag":"div","text":_vm.text,"options":_vm.options},on:{"edit":_vm.applyTextEdit}}),_vm._v(" "),(_vm.showHint)?_c('p',{staticClass:"nuttrema-medium-editor__help",domProps:{"innerHTML":_vm._s(_vm._markdown.renderInline(_vm.$t(_vm.hintLabel)))}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb3952fc","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/editor/nuttrema-medium-editor.vue
// module id = 3297
// module chunks = 0